import axiosInstance from './axios-instance';

interface InviteMemberPayload {
  accountId: number;
  email: string;
  roles: number[];
  canSeePricing: boolean;
  isAdmin: boolean;
}

const updateUsersPassword = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/users/editPassword`, payload);
    return response.data;
  } catch (error) {
    console.error(`Error while updating users password:`, error);
    throw error;
  }
};

const handleUpdateUser = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/users/updateUser`, payload);
    return response.data;
  } catch (error) {
    console.error(`Error while updating user:`, error);
    throw error;
  }
};

const getUsers = async (params: { page: number, limit: number, search: string }) => {
  try {
    const query = new URLSearchParams({
      page: params.page.toString(),
      limit: params.limit.toString(),
      search: params.search || '',
    }).toString();
    
    const response = await axiosInstance.get(`/users?${query}`);
    return response.data;
  } catch (error) {
    console.error(`Error while getting users:`, error);
    throw error;
  }
};

const adminLogin = async (payload: { userId: number; adminAccountId: number }) => {
  try {
    const response = await axiosInstance.post(`/users/adminLogin`, payload);
    return response.data;
  } catch (error) {
    console.error(`Error while admin login:`, error);
    throw error;
  }
};

const getUser = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`/users/get-one`, payload)
    return response.data
  } catch (error) {
    console.error("Error while fetching user:", error)
    throw error
  }
}

const inviteMember = async (payload: InviteMemberPayload) => {
  try {
    const response = await axiosInstance.post('/users/invite-member', payload);
    return response.data;
  } catch (error) {
    console.error('Error while inviting team member:', error);
    throw error;
  }
};

export { updateUsersPassword, handleUpdateUser, getUsers, adminLogin, getUser, inviteMember };
